module.exports = __webpack_public_path__ + "img/barrel_grey.0a4292cb.svg";